<!--
 * @Author: zhanghan
 * @Date: 2021-01-23 21:55:45
 * @LastEditors: zhanghan
 * @LastEditTime: 2022-07-07 16:16:48
 * @Descripttion: 文章详情
-->
<template>
  <div class="articleComponent">
    <v-content
      :articleContent="articleContent"
      :tags="tags"
      :userInfo="userInfo"
      :isLoading="isLoading"
    ></v-content>
  </div>
</template>

<script>
import Content from "@/components/article/content/content";
import { queryOneArticle, addArticleView } from "@/bmob.js";

export default {
  components: {
    "v-content": Content
  },
  data() {
    return {
      articleContent: {},
      tags: [],
      articleId: 0,
      isLoading: false
    };
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/article") > -1) {
        this.$nextTick(() => {
          this.articleId = to.query.articleId;
          this.getArticle();
        });
      }
    }
  },
  created() {
    this.articleId = this.$route.query.articleId;
    this.getArticle();
  },
  methods: {
    getArticle() {
      // todo 用户头像问题
      this.isLoading = true;
      queryOneArticle(this.articleId)
        .then(result => {
          this.isLoading = false;
          // 浏览次数+1
          result.view = !result.view ? 1 : result.view + 1;
          this.articleContent = result;
          this.tags = this.articleContent.tags;
          // 保存浏览次数
          addArticleView({ objectId: result.objectId, view: result.view });
        })
        .catch(err => {
          this.isLoading = false;
          this.$emit("showMessage", err);
          setTimeout(() => {
            this.$router.push({ path: "/blog" });
          }, 1500);
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/style/common.less");
.articleComponent {
  max-width: 1024px;
  margin: auto;
  padding: 0 30px;
}
.error-wrapper {
  width: 75%;
}
</style>



// WEBPACK FOOTER //
// index.vue?153d3f9a